import { render, staticRenderFns } from "./viewSelectedCities.vue?vue&type=template&id=2f8dc1bf&scoped=true"
import script from "./viewSelectedCities.vue?vue&type=script&lang=js"
export * from "./viewSelectedCities.vue?vue&type=script&lang=js"
import style0 from "./viewSelectedCities.vue?vue&type=style&index=0&id=2f8dc1bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8dc1bf",
  null
  
)

export default component.exports